module.exports = __webpack_public_path__ + "static/img/top.30df78c0.png";